.labelCell {
  white-space: nowrap;
}

.coachCell {
  color: var(--hcr-content-secondary-color);
}

// Scope row-hover to <td>s so the rowSpanned label <th> stays inert.
tbody.grid > tr:hover td,
tbody.grid > tr:hover th {
  background-image: none;
}

tbody.grid > tr:has(td:hover) td {
  background-image: var(--hcr-hover-layer-color);
}
